export enum GiftCardSalesChannelEnum {
  ONLINE_SALES = 1,
  PIE_DIGITAL = 2,
  PIE_CORPORATE = 3,
  TRANSFER = 4
}
